export const PROVET_PAY_PAYOUT_TRANSACTION_STALE_TIME = 1000 * 5 * 60 // 5 minutes

export const PROVET_PAY_PAYOUT_TRANSACTION_RESOURCE_TYPES = {
  FILTERS: 'ProvetpayPayoutTransactionFilters',
  TRANSACTION: 'ProvetpayPayoutTransaction',
} as const

export const PROVET_PAY_PAYOUT_TRANSACTION_TYPE = {
  Chargeback: 'Chargeback',
  ChargebackReversed: 'ChargebackReversed',
  FundTransfer: 'FundTransfer',
  Payment: 'Payment',
  Refund: 'Refund',
  Surcharge: 'Surcharge',
} as const

export const PROVET_PAY_PAYOUT_TRANSACTION_COLUMNS = {
  Fees: {
    id: 'fees',
    accessorKey: 'attributes.fees',
  },
  GrossAmount: {
    id: 'gross_amount',
    accessorKey: 'attributes.gross_amount',
  },
  InvoiceNumber: {
    id: 'invoice_number',
    accessorKey: 'attributes.invoice_number',
  },
  NetPayoutAmount: {
    id: 'net_payout_amount',
    accessorKey: 'attributes.net_payout_amount',
  },
  PaymentMethod: {
    id: 'payment_method',
    accessorKey: 'attributes.payment_method',
  },
  TransactionDate: {
    id: 'transaction_ts_utc',
    accessorKey: 'attributes.transaction_ts_utc',
  },
  TransactionType: {
    id: 'transaction_type',
    accessorKey: 'attributes.transaction_type',
  },
} as const

export const PROVET_PAY_PAYOUT_TRANSACTION_ENDPOINTS = {
  FILTERS:
    '/reports_v2/payouts/provet-pay/:payout_psp_reference/transactions/filters',
  LIST: '/reports_v2/payouts/provet-pay/:payout_psp_reference/transactions/',
} as const

export const PROVET_PAY_PAYOUT_TRANSACTION_URLS = {
  FILTERS:
    '/{provet_id}/api/reports_v2/payouts/provet-pay/{payout_psp_reference}/transactions/filters',
  LIST: '/{provet_id}/api/reports_v2/payouts/provet-pay/{payout_psp_reference}/transactions/',
} as const

export const PROVET_PAY_PAYOUT_TRANSACTION_DEFAULT_FIELDS_REQUEST = {
  [PROVET_PAY_PAYOUT_TRANSACTION_RESOURCE_TYPES.TRANSACTION]: [
    ...Object.values(PROVET_PAY_PAYOUT_TRANSACTION_COLUMNS).map(
      (col) => col.id,
    ),
    'invoice_id',
    'payment_transaction_id',
    'currency',
  ],
}
